// Generated by psc version 0.10.2
"use strict";
var $foreign = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-st/src/Control/Monad/ST.js");
var Control_Monad_Eff = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-eff/src/Control/Monad/Eff.purs");
var pureST = function (st) {
    return Control_Monad_Eff.runPure($foreign.runST(st));
};
module.exports = {
    pureST: pureST, 
    modifySTRef: $foreign.modifySTRef, 
    newSTRef: $foreign.newSTRef, 
    readSTRef: $foreign.readSTRef, 
    runST: $foreign.runST, 
    writeSTRef: $foreign.writeSTRef
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-st/src/Control/Monad/ST.purs
// module id = 107
// module chunks = 0